import { createFileRoute } from '@tanstack/react-router'
import { AdminTagsPage } from '@/features/tags/pages/admin-tags-page'

export const Route = createFileRoute('/tags')({
  staticData: { title: 'Tags' },
  component: AdminTagsPage,
})
